var carouselConstants = require('src/interlock/no-ui/constant/carousel');

function indexIsValid(index) {
    return typeof index === 'number' && index >= 0;
}

module.exports = {
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} index - jump to
     * @param {number} speed - in ms for carousel to perform slide jump
     */
    changeSlide: function ($carousel, index, speed) {
        if (!indexIsValid(index)) { // Only positive numbers
            return;
        }
        $carousel.trigger('to.owl.carousel', [index, speed || carouselConstants.DEFAULT_TIMEOUT]);
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} index - index of slide to remove
     */
    removeSlide: function($carousel, index) {
        if (!indexIsValid(index)) { // Only positive numbers
            return;
        }
        $carousel.trigger('remove.owl.carousel', index);
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} slide - blob of what you want to append to carousel
     * @param {number} index - optional, if included, will append to this slot in carousel otherwise at the end
     */
    addSlide: function($carousel, slide, index) {
        if(typeof index == 'number') {
            $carousel.trigger('add.owl.carousel', [slide, index]);
        } else {
            $carousel.trigger('add.owl.carousel', [slide]);
        }
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     */
    refresh: function($carousel) {
        $carousel.trigger('refresh.owl.carousel');
    }


};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/carousel-events.js
// module id = 89
// module chunks = 0 1 3 7 8 10 23 26 27 30